import React from 'react'
import PropTypes from 'prop-types'
import { TabButtonFilled, TabButtonOutlined } from 'secondstep-components'

const AdminDashboardTabButton = ({
  className,
  isActive,
  label,
  onClick,
  onKeyPress,
  ultraWide,
  wide,
}) => {
  return (
    <div className={className}>
      {isActive && (
        <TabButtonFilled
          label={label}
          onClick={onClick}
          onKeyPress={onKeyPress}
          ultraWide={ultraWide}
          wide={wide}
        />
      )}
      {!isActive && (
        <TabButtonOutlined
          label={label}
          onClick={onClick}
          onKeyPress={onKeyPress}
          ultraWide={ultraWide}
          wide={wide}
        />
      )}
    </div>
  )
}

AdminDashboardTabButton.propTypes = {
  className: PropTypes.string,
  isActive: PropTypes.bool,
  label: PropTypes.string,
  onClick: PropTypes.func,
  onKeyPress: PropTypes.func,
  ultraWide: PropTypes.bool,
  wide: PropTypes.bool,
}

export default AdminDashboardTabButton
